import { HelpSystemSidebarModel } from './../../modules/layout/help-sidebar/help-system-sidebar.model';
import { EventEmitter, Injectable, Output } from '@angular/core';
import { BehaviorSubject, Observable, of, ReplaySubject } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { ApiService } from './api.service';
import {
  ConfirmDialogModel,
  ConfirmDialogComponent,
} from '../components/confirm-dialog/confirm-dialog.component';
import { AccountModel } from 'src/app/modules/operate/account-list/models/account.model';
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
/* eslint-disable */

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  @Output() clickHamburger: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  @Output() clickHamburgerHelp: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  @Output() selectedAccountChanged: EventEmitter<object> =
    new EventEmitter<object>();
  @Output() newHelpId: BehaviorSubject<string> = new BehaviorSubject<string>(
    null
  );
  selectedHelpItem: HelpSystemSidebarModel;
  selectedHelpId;
  accountsSubject: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  accessListDataSubject = new ReplaySubject<string[]>(1);
  customerProfileImage: string;

  private accounts$?: Observable<any[]>; // cached stream

  accounts: any = [];
  selectedAccount = {
    Id: null,
    Name: null,
    Description: null,
    CustomerId: null,
    customerProfileImage: null,
  };
  accountManagers = [];
  accessControlList = [];
  selectedAccountToUpdate: AccountModel;
  constructor(
    private snackBar: MatSnackBar,
    private apiService: ApiService,
    private dialog: MatDialog
  ) {}

  successMessage = (
    message: string,
    durationInSeconds: number = 5,
    verticalPosition: MatSnackBarVerticalPosition = 'top',
    horizontalPosition: MatSnackBarHorizontalPosition = 'right'
  ) => {
    this.snackBarMessage(
      message,
      durationInSeconds,
      verticalPosition,
      horizontalPosition,
      'mat-primary'
    );
  };

  errorMessage = (
    message: string,
    durationInSeconds: number = 5,
    verticalPosition: MatSnackBarVerticalPosition = 'top',
    horizontalPosition: MatSnackBarHorizontalPosition = 'right'
  ) => {
    this.snackBarMessage(
      message,
      durationInSeconds,
      verticalPosition,
      horizontalPosition,
      'mat-warn'
    );
  };

  snackBarMessage = (
    message: string,
    durationInSeconds: number = 2,
    verticalPosition: MatSnackBarVerticalPosition = 'bottom',
    horizontalPosition: MatSnackBarHorizontalPosition = 'center',
    panelClass = 'mat-primary'
  ) => {
    {
      this.snackBar.open(message, '', {
        duration: durationInSeconds * 1000,
        verticalPosition,
        horizontalPosition,
        panelClass: ['mat-toolbar', panelClass],
      });
    }
  };

  confirm(
    message = `Are you sure you want to do this?`,
    title = 'Confirm'
  ): Observable<boolean> {
    const dialogData = new ConfirmDialogModel(title, message);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: '400px',
      data: dialogData,
      autoFocus: false,
    });
    return dialogRef.afterClosed();
  }

  // getAccounts(discounts?): Observable<any> {
  //   return this.apiService
  //     .get<any>('accounts?' + Math.random(), discounts)
  //     .pipe(
  //       map((result: any) => {
  //         if (result.length > 0) {
  //           const accountManagers = result.at(-2);
  //           const accessControlList = result.at(-3);

  //           if (Object.keys(accountManagers)?.[0] === 'account_managers') {
  //             this.accountManagers = accountManagers?.account_managers;
  //             result.splice(-1, 1);
  //           }

  //           if (Object.keys(accessControlList)?.[0] === 'access_control_list') {
  //             this.accessControlList = accessControlList?.access_control_list;

  //             result.splice(-3, 1);
  //           }

  //           this.accounts = result;

  //           this.accessListDataSubject.next(this.accessControlList);
  //         }

  //         if (discounts) {
  //           return result;
  //         } else {
  //           let innerAccounts: Array<any> = Object.values(result);

  //           try {
  //             this.accounts = innerAccounts
  //               ?.sort((a, b) =>
  //                 a?.name?.toLowerCase() > b.name?.toLowerCase() ? 1 : -1
  //               )
  //               ?.map((account) => {
  //                 return {
  //                   Id: account?.id,
  //                   PayerId: account?.payer_id,
  //                   Name: account?.name,
  //                   Email: account?.email,
  //                   Description: account?.description,
  //                   CustomerId: account?.customer_id,
  //                   // NetsyncioManaged: account?.netsyncio_managed ? 'Yes' : 'No',
  //                   AwsServicesDiscount: account?.aws_services_bill_discount,
  //                   AwsSupportDiscount: account?.aws_support_bill_discount,
  //                   SupportPlan: account?.support_level,
  //                   FirstBillableMonth: account?.first_billable_month,
  //                   LastBillableMonth: account?.last_billable_month,
  //                   BillableAccount: account?.billable_account,
  //                   ViewableAccount: account?.billing_viewable,
  //                   CustomerProfileImage: account?.customer_profile_image,
  //                   Status: account?.status,
  //                 };
  //               });
  //           } catch (err) {
  //             console.log(err);
  //           }
  //         }

  //         this.accountsSubject.next(this.accounts);
  //         this.accessListDataSubject.next(this.accessControlList);

  //         if (this.selectedAccount.Id == null) {
  //           this.selectedAccount = this.accounts[1];
  //           this.selectedAccountChanged.next(this.accounts[1]);
  //         }

  //         return this.accounts;
  //       }),
  //       catchError((err) => {
  //         console.log('error!');

  //         return of(0);
  //       })
  //     );
  // }

  getAccountsCached(force = false, discounts?: any): Observable<any[]> {
    if (!this.accounts$ || force) {
      // reuse your existing method; cache its last value
      this.accounts$ = this.getAccounts(discounts).pipe(shareReplay(1));
    }
    return this.accounts$;
  }

  getAccounts(discounts?): Observable<any> {
    return this.apiService
      .get<any>('accounts?' + Math.random(), discounts)
      .pipe(
        map((result: any[]) => {
          if (!Array.isArray(result) || result.length === 0) {
            this.accounts = [];
            this.accountManagers = [];
            this.accessControlList = [];
            this.accessListDataSubject.next(this.accessControlList);
            this.accountsSubject.next(this.accounts);

            return this.accounts;
          }

          // find meta blocks by key (order-agnostic)
          const idxACL = result.findIndex(
            (o) => o && typeof o === 'object' && 'access_control_list' in o
          );
          const idxMgr = result.findIndex(
            (o) => o && typeof o === 'object' && 'account_managers' in o
          );
          const idxImg = result.findIndex(
            (o) => o && typeof o === 'object' && 'customer_profile_image' in o
          );

          if (idxMgr > -1)
            this.accountManagers = result[idxMgr].account_managers ?? [];
          if (idxACL > -1)
            this.accessControlList = result[idxACL].access_control_list ?? [];
          if (idxImg > -1)
            this.customerProfileImage =
              result[idxImg].customer_profile_image ?? null;
          // remove meta blocks WITHOUT shifting targets mid-way
          [idxACL, idxMgr, idxImg]
            .filter((i) => i > -1)
            .sort((a, b) => b - a) // splice highest index first
            .forEach((i) => result.splice(i, 1));
          // what remains are only accounts
          this.accounts = result;
          this.accessListDataSubject.next(this.accessControlList);

          if (discounts) {
            return result; // keep your original behavior
          }

          // no need for Object.values(result) – result is already an array
          this.accounts = result
            .slice()
            .sort((a, b) =>
              a?.name?.toLowerCase() > b?.name?.toLowerCase() ? 1 : -1
            )
            .map((account) => ({
              Id: account?.id,
              PayerId: account?.payer_id,
              Name: account?.name,
              Email: account?.email,
              Description: account?.description,
              CustomerId: account?.customer_id,
              AwsServicesDiscount: account?.aws_services_bill_discount,
              AwsSupportDiscount: account?.aws_support_bill_discount,
              SupportPlan: account?.support_level,
              FirstBillableMonth: account?.first_billable_month,
              LastBillableMonth: account?.last_billable_month,
              BillableAccount: account?.billable_account,
              ViewableAccount: account?.billing_viewable,
              CustomerProfileImage: account?.customer_profile_image ?? null,
              Status: account?.status,
            }));

          this.accountsSubject.next(this.accounts);
          this.accessListDataSubject.next(this.accessControlList);
          if (!this.selectedAccount?.Id && this.accounts.length) {
            // avoid [1] which is undefined when there’s only one account
            this.selectedAccount = this.accounts[0];
            this.selectedAccountChanged.next(this.selectedAccount);
          }

          return this.accounts;
        }),
        catchError((err) => {
          console.log('error!', err);
          this.accounts = [];
          this.accountsSubject.next(this.accounts);
          this.accessListDataSubject.next([]);
          return of([]); // return consistent type
        })
      );
  }

  updateAccount(payload) {
    return this.apiService.put(`update-account-columns`, payload);
  }

  getHelpSystemItem(id) {
    return this.apiService.get(`help-system?id=` + id);
  }

  getUrlMappingMainURL(shortUrl) {
    return this.apiService.post(`url-mappings/search`, { shortUrl: shortUrl });
  }

  updateCustomerProfileInfo(
    customerProfileData,
    isAzureUserProfileExist = false,
    isAzureIDP = false
  ) {
    if (isAzureIDP) {
      if (isAzureUserProfileExist) {
        return this.apiService.patch(
          `ad-employee-profile`,
          customerProfileData
        );
      } else {
        return this.apiService.post(`ad-employee-profile`, customerProfileData);
      }
    } else {
      return this.apiService.patch(
        `update-auth0-customer-profile`,
        customerProfileData
      );
    }
  }

  showHelpSidebar(id) {
    if (this.clickHamburgerHelp.value) {
      this.clickHamburgerHelp.next(false);
      this.newHelpId.next(id);
    }
  }

  getAzureUserInfo() {
    return this.apiService.get(`ad-employee-profile`).pipe(
      map((res: any) => {
        if (typeof res == 'string') {
          return res;
        } else {
          return {
            firstName: res?.first_name,
            lastName: res?.last_name,
            phone: res?.phone,
            defaultPage: res?.default_page,
            defaultMode: res?.default_mode,
            defaultDisplayAccount: res?.default_display_account,
          };
        }
      })
    );
  }
}
